import { createContext } from "react";
const UserDetailContext = createContext(null);
const LoadingContext = createContext(null);
const DashboardFilters = createContext(null);
const SaveDataContext = createContext(null);
const TermsContext = createContext(null);
const MasteryLevelContext = createContext(null);
const SubjectsContext = createContext(null);
const StatusContext = createContext(null);
const FeatureContext = createContext(null);
export {
  DashboardFilters,
  FeatureContext,
  LoadingContext,
  MasteryLevelContext,
  SaveDataContext,
  StatusContext,
  SubjectsContext,
  TermsContext,
  UserDetailContext,
};
